/**
 * Tipos y constantes del cliente de auditoría UX.
 */

export const AUD_TIPO = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  NAVIGATE: 'NAVIGATE',
  CLICK: 'CLICK',
  UPLOAD: 'UPLOAD',
  DOWNLOAD: 'DOWNLOAD',
  FORM_SUBMIT: 'FORM_SUBMIT',
  API_MUTATION: 'API_MUTATION',
  EXPORT: 'EXPORT',
  ERROR_UI: 'ERROR_UI',
} as const;

export const AUD_CATEGORIA = {
  AUTH: 'AUTH',
  NAVEGACION: 'NAVEGACION',
  ARCHIVO: 'ARCHIVO',
  CONFIGURACION: 'CONFIGURACION',
  MOTOR_REGLAS: 'MOTOR_REGLAS',
  MATRIZ: 'MATRIZ',
  REPORTE: 'REPORTE',
  SEGURIDAD: 'SEGURIDAD',
} as const;

export type AudTipoEvento = (typeof AUD_TIPO)[keyof typeof AUD_TIPO];
export type AudCategoria = (typeof AUD_CATEGORIA)[keyof typeof AUD_CATEGORIA];

export interface AudEventoPayload {
  id?: string;
  fechaEvento?: string;
  sesionId?: string;
  tipoEvento: AudTipoEvento | string;
  categoria: AudCategoria | string;
  pantallaCodigo?: string;
  pantallaLabel?: string;
  ruta?: string;
  rutaParams?: Record<string, unknown>;
  elementoCodigo?: string;
  elementoLabel?: string;
  entidadTipo?: string;
  entidadId?: string;
  resultado?: 'OK' | 'ERROR' | 'CANCELADO' | 'PENDIENTE';
  httpMetodo?: string;
  httpRuta?: string;
  httpStatus?: number;
  mensaje?: string;
  metadata?: Record<string, unknown>;
  correlationId?: string;
  recaudadorId?: string;
  periodoId?: string;
}

export interface AudEventoItem extends AudEventoPayload {
  id: string;
  fechaEvento: string;
  fechaIngesta: string;
  usuId: string;
  usuEmail: string | null;
  usuNombre: string | null;
  roles: unknown;
  ip: string | null;
  userAgent: string | null;
}

export interface AudEventosPagination {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
}

export interface AudEventosPage {
  items: AudEventoItem[];
  pagination: AudEventosPagination;
}

export interface AudCatalogoPantalla {
  codigo: string;
  label: string | null;
}

export interface AudCatalogoUsuario {
  usuId: string;
  usuEmail: string | null;
  usuNombre: string | null;
}
